module.exports = __webpack_public_path__ + "img/01-bep.a8be03b2.jpg";